import WrapperLayout from 'components/Layout';
import Main from "./Components/Main"
const LeadIntelligence = () =>{
    return(
        <>
        <WrapperLayout>
            <Main/>
        </WrapperLayout>
    </>
    )
}
export default LeadIntelligence